module.exports = __webpack_public_path__ + "img/lifter-footer.f762ebe6.svg";